import React from "react";
import { Table, TableHead, TableRow, TableCell, TableBody } from "@material-ui/core";
import { ButtonIcon } from "@loanbossinc/component-library";
import moment from "moment";
import numeral from "numeral";
import "./dealScreenerTableStyles.css";

const DealScreenerTable = ({ onNameClick, onEmailClick, dealScreenerData, isEmailCampaign }) => (
  <div className="dl-scrn-table-root-wrapper">
    <Table className="dl-scrn-table-root">
      <TableHead className="dl-scrn-table-header-wrapper">
        <TableRow>
          <TableCell>Deal Name</TableCell>
          <TableCell>Maturity</TableCell>
          <TableCell>Current Loan Balance</TableCell>
          <TableCell>Rate</TableCell>
          <TableCell colSpan={2}>Prepayment Penalty</TableCell>
          <TableCell>Par Prepayment Date</TableCell>
          <TableCell>In Lockout?</TableCell>
          {!isEmailCampaign && <TableCell />}
        </TableRow>
      </TableHead>
      <TableBody className="dl-scrn-table-body-wrapper">
        {
          dealScreenerData?.map(({ id, currentDeal }, idx) => {
            const formatDate = date => moment(date).utc().format("MM/DD/yyyy");
            const maturityDate = currentDeal?.maturity !== undefined ? formatDate(currentDeal?.maturity) : "";
            const prepaymentDate = currentDeal?.prepaymentPenalty?.prepaymentDate ? formatDate(currentDeal?.prepaymentPenalty?.prepaymentDate) : "";

            return (
              <TableRow key={currentDeal?.name ?? idx}>
                {
                  isEmailCampaign ?
                    <TableCell className="dl-scrn-table-cell-disabled">{currentDeal?.name}</TableCell> :
                    <TableCell onClick={() => onNameClick(id)}>{currentDeal?.name}</TableCell>
                }
                <TableCell>{maturityDate}</TableCell>
                <TableCell className="dl-scrn-table-cell-accounting">
                  <span>$</span>
                  <span>{numeral(currentDeal?.loanAmount).format("0,0")}</span>
                </TableCell>
                <TableCell>{numeral(currentDeal?.rate).format("0.00%")}</TableCell>
                <TableCell className="dl-scrn-table-cell-accounting">
                  <span>$</span>
                  <span>{numeral(currentDeal?.prepaymentPenalty?.amount).format("0,0")}</span>
                </TableCell>
                <TableCell>{numeral(currentDeal?.prepaymentPenalty?.percentOfLoanAmount).format("0,0.00%")}</TableCell>
                <TableCell>{prepaymentDate}</TableCell>
                <TableCell>{currentDeal?.prepaymentPenalty?.isLockout ? "Yes" : "No"}</TableCell>
                {!isEmailCampaign && <TableCell><ButtonIcon onClick={() => onEmailClick(id)} iconName="mail_outline" /></TableCell>}
              </TableRow>
            );
          })
        }
      </TableBody>
    </Table>
  </div>
);

export default DealScreenerTable;
